module.exports = __webpack_public_path__ + "static/media/EnergyPole_512_albedo.b0e73c71.jpg";